import React from "react";
import { iframeResizer } from "iframe-resizer";
import { AllowableTransversalOrigins } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import { setInProgressForComponent } from "./../../actions/networkStateActions";
import { animateScroll } from "react-scroll";
export const TAGGED_ELEMENT = "taggedElement";
export const BODY_OFFSET = "bodyOffset";

const handleIframeResize = (heightCalculationMethod = BODY_OFFSET) => {
  iframeResizer(
    {
      heightCalculationMethod,
      checkOrigin: AllowableTransversalOrigins
    },
    "#iframe"
  );
};

export class IFrameWrapper extends React.Component {
  componentDidMount = () => {
    this.props.setInProgressForComponent(true);

    window.addEventListener("message", this.handleFormSubmitMessage);
  };

  componentWillUnmount = () => {
    window.removeEventListener("message", this.handleFormSubmitMessage);
  };

  handleFormSubmitMessage = (event) => {
    if (
      event &&
      (event.data === "form_submit" || event.data === "form_back") &&
      AllowableTransversalOrigins.includes(event.origin)
    ) {
      animateScroll.scrollToTop({
        duration: 750,
        smooth: true
      });
    }
  };

  onLoadCallback = () => {
    handleIframeResize(this.props.heightCalculationMethod);
    this.props.setInProgressForComponent(false);
  };

  render = () => {
    return (
      <iframe
        frameBorder="0"
        id="iframe"
        title={this.props.title}
        src={this.props.iframeSrc}
        style={{ width: "100%" }}
        onLoad={() => this.onLoadCallback()}
        scrolling="no"
      />
    );
  };
}

export default connect(null, { setInProgressForComponent })(IFrameWrapper);
